
import MainPage from "../pages/MainPage/MainPage";



export const routes = [
    { path: '*', element: MainPage },


];


